/**
 * The "Powered by Eventgram" line on guest-facing pages, with the brand name
 * as a link back to the homepage.
 *
 * Every guest who scans a table card is someone who might host an event of
 * their own, so this line is the cheapest acquisition channel the product has.
 * It opens in a new tab: a guest mid-upload must never lose the page they are
 * on. `ref` tells the Worker where the visit came from; it logs that on the
 * homepage request (see src/index.ts), so the clicks can be counted without
 * any analytics script on the guest's phone.
 *
 * The sentence is translated (lib/i18n.ts) and every translation contains the
 * word "Eventgram" once, so the link is cut out of the translated text rather
 * than assembled from fragments that would not survive word order changes.
 */
export function PoweredBy({ text, source }: { readonly text: string; readonly source: string }) {
  const at = text.indexOf("Eventgram");
  if (at < 0) return <p className="guest-foot">{text}</p>;

  return (
    <p className="guest-foot">
      {text.slice(0, at)}
      <a href={`/?ref=${encodeURIComponent(source)}`} target="_blank" rel="noopener">
        Eventgram
      </a>
      {text.slice(at + "Eventgram".length)}
    </p>
  );
}
